<template>
  <v-card>
    <v-overlay
      :value="loading"
      :absolute="true"
      color="#fff"
      :opacity="1"
      
    >
      <v-progress-circular 
      indeterminate
      :value="60"
      color="blue-grey"
      >  
      </v-progress-circular>
    </v-overlay>
    
    <div
      v-for="partner in partners"
      :key="partner.code"
    >
      <v-divider />
      <app-partner-config
        :partner="partner"
        :data="data"
      />
    </div>
    <v-card-actions class="d-flex flex-row-reverse">
      <v-btn 
        @click="save"
        rounded 
        color="success" 
        style="margin: 10px"
        :loading="saveLoading"
        :disabled="saveLoading"
      >
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import axios from 'axios'
  import PartnerConfig from './PartnerConfig.vue'

  export default {
    props: ['device', 'page'],
    components: {
      AppPartnerConfig: PartnerConfig,
    },
    data(){
      return {
        loading: false,
        saveLoading: false,
        data : {
        },
        partners: [
          /*
          {
            name: "Video Intelligence",
            code: 'vi',
            fields : [
              { model: 'viSelector', label: 'Selector'},
              { model: 'viPosition', label: 'Position'},
              { model: 'viStyle', label: 'Style'},
              { model: 'viPlacementId', label: 'PlacementId'}
            ]
          },
          */
          {
             name: "Is Ads Wrapper active",
             code : 'adsWrapper',
             fields : []
          },
          {
            name: "Dailymotion Injected Slot",
            code: 'dm',
            fields: [
              { model: 'dmSelector', label: 'Selector'},
              { model: 'dmPlayerId', label: 'PlayerId'},
              { model: 'dmPlaylistId', label: 'PlaylistId'},
            ],
          },{
            name: "Dailymotion Display Video Competition Slot",
            code: 'displayVideoCompetition',
            fields: [
              { model: 'displayVideoCompetitionSlot', label: 'Selector'},
              { model: 'isVideoForced', label : 'IsVideoForced'}
            ],
          },{
            name: "Dailymotion",
            fields: [
              { model: 'dmPosition', label: 'Position'},
              { model: 'dmStyle', label: 'Style'},
              { model: 'dmDefaultVideoId', label: 'Default Video Id'},
              { model: 'dmSiblingsIds', label : 'Siblings Ids'},
              { model: 'dmHeaderSelector', label : 'Header Selector'},
              { model: 'dmMessage', label : 'Message'},
              { model: 'dfpVideoAdUnit', label : 'Dfp Video AdUnit'}
            ]
          },
          {
            name: "Appnexus",
            code: "videoAppnexus",
            fields: [
              { model: "videoAppnexusPlacementId", label: "PlacementId"}
            ]
          },
          {
            name: "Smart Ad Server",
            code: "videoSmart",
            fields: [
              { model: "videoSmartDomain", label: 'Domain'},
              { model: "videoSmartSiteId", label: 'SiteId'},
              { model: "videoSmartPageId", label: 'PageId'},
              { model: "videoSmartFormatId", label: 'FormatId'},
            ]
          },
          {
            name: "OpenX",
            code: "videoOpenx",
            fields: [
              { model: "videoOpenxDomain", label: "Domain"},
              { model: "videoOpenxAdUnitId", label: "AdUnitId"}
            ]
          },
          {
            name: "Gravity",
            code: "videoGravity",
            fields: [
              { model: "videoGravityPlacementId", label: "PlacementId"}
            ]
          },
          {
            name: "Freewheel",
            code: "videoFreewheelSsp",
            fields: [
              { model: "videoFreewheelSspZoneId", label: "ZoneId"}
            ]
          },
          {
            name: "Rubicon",
            code: "videoRubicon",
            fields: [
              { model: "videoRubiconAccountId", label: "AccountId"},
              { model: "videoRubiconSiteId", label: "SiteId"},
              { model: "videoRubiconZoneId", label: "ZoneId"}
            ]
          },
          {
            name: "Verizon",
            code: "videoOneVideo",
            fields: [
            ]
          },
        ]
          
      }
    },
    created(){

      this.getDataFromApi()
    },
    watch: {
      device(){
        this.getDataFromApi()
      }
    },
    methods: {
      async getDataFromApi(){
        this.loading = true
        const request = {
          type : "management/pagedevice",
          action : "getDetails",
          data : {pageId : this.page.id, deviceId: this.device.id }
        };
        try {
          const accessToken = await this.$auth.getAccessToken()
          const response = await axios.post('/', JSON.stringify(request),{ headers: {Authorization: `Bearer ${accessToken}`}})
          console.log(response.data)
          this.data = response.data
          Object.keys(this.data).forEach(key =>{
            this.data[key] = (key.substr(-6) == "Active" && this.data[key] == null) ? 0 : this.data[key]
          })
          
          this.loading= false
        } catch (e) {
          this.$router.push("/login")
          console.error(e)
          this.loading = false  
        }
      },
      async save(){
        this.data.pageName = this.data.pageName == undefined ? "" : this.data.pageName
        this.data.deviceName = this.data.deviceName == undefined ? "" : this.data.deviceName
        Object.keys(this.data).forEach(key =>{
            this.data[key] = this.data[key] == null ? "" : this.data[key]
        })
        this.saveLoading = true
        const request = {
          type : "management/pagedevice",
          action : "saveDetails",
          data : this.data
        };
        try {
          const accessToken = await this.$auth.getAccessToken()
          await axios.post('/', JSON.stringify(request),{ headers: {Authorization: `Bearer ${accessToken}`}})
          this.saveLoading = false
          this.$emit('pageUpdated')
        } catch (e) {
          console.error(e)
          this.saveLoading = false
        }
      }
    }
  }
</script>